import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionCtl } from 'lib-klab-core';
import { hasCustomerPortalAccess } from '../../modules/home/customer-iam-access.util';

export const noAuthGuard: CanActivateFn = () => {
    const router = inject(Router);
    const sessionCtl = inject(SessionCtl);

    const isLoggedIn = sessionCtl.loggedInCheckSync();
    if (!isLoggedIn || !hasCustomerPortalAccess(sessionCtl.menu)) return true;

    return router.parseUrl('/app');
};
